export function getCustomerBucketName(prefix: string, groupId: string) {
  return `${prefix}${groupId}`;
}
